/**
 * Created by Kshama on 25/5/16.
 */
angular.module('qkr').service('checkBrowserService', ['$window', function($window) {
    return {
        isUnsupportedBrowser() {
            const browserInfo = $window.navigator.userAgent.toLowerCase();
            const browserFlags = {};
            browserFlags.ISOLD = false;

            browserFlags.ISIE = browserInfo.indexOf('msie') > 0;
            if (browserFlags.ISIE) {
                browserFlags.ISIE9DOWN = parseInt(browserInfo.split('msie')[1]) < 10;
                browserFlags.ISOLD = browserFlags.ISIE9DOWN;
            }
            return browserFlags.ISOLD;
        }
    };
}]);



// WEBPACK FOOTER //
// ./src/services/checkBrowser.service.js